var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDiamond = function SvgDiamond(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.223 3H7.777a.95.95 0 0 0-.806.457L3.687 8.834h16.625L17.03 3.457a.96.96 0 0 0-.345-.335.94.94 0 0 0-.461-.122Zm-4.926 17.682A.95.95 0 0 0 12 21a.93.93 0 0 0 .703-.318l8.797-9.904h-19z"
  })));
};
export default SvgDiamond;